import React, { useState, useEffect } from "react";
import { useMediaQuery, Box, IconButton } from "@mui/material";
import { customColour } from "../data/colour";
import { isTabWidth } from "../data/database";
import { useResponsiveFontSize } from "../functions";

const Slider = ({
  slides,
  aspectRatio = "3/1",
  titleFontSize = "2.5rem",
  // textFontSize = "1rem",
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const isTab = useMediaQuery(isTabWidth);

  const textFontSize = useResponsiveFontSize();
  const back = "../../images/icons/back.png";
  const forward = "../../images/icons/forward.png";

  // Function to go to the next slide
  const nextSlide = () => {
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  // Function to go to the previous slide
  const prevSlide = () => {
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  return (
    <Box
      sx={{
        cursor: "pointer",
        position: "relative",
        width: "100%",
        aspectRatio: aspectRatio,
        overflow: "hidden",
        margin: "auto",
        borderRadius: "0.5rem",
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "background-image 0.5s ease-in-out",
        backgroundImage: slides[currentSlide].background,
        boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
        marginTop: "2.5rem",
        marginBottom: "2.5rem",
        "&:hover .slider-buttons": {
          visibility: "visible",
        },
      }}
    >
      <Box
        sx={{
          maxHeight: "50%",
          position: "absolute",
          bottom: "50px",
          left: "30px",
          marginRight: "30px",
        }}
      >
        <Box
          sx={{
            fontSize: titleFontSize,
            fontWeight: "300",
            color: `${customColour.lightBlue}`,
          }}
        >
          {slides[currentSlide].tagline}
        </Box>
        <Box
          sx={{
            fontSize: textFontSize,
            fontWeight: "100",
            color: customColour.white,
            marginTop: "10px",
          }}
        >
          {slides[currentSlide].description}
        </Box>
      </Box>
      <Box
        className="slider-buttons"
        sx={{
          position: "absolute",
          top: isTab ? "10%" : "50%",
          transform: "translateY(-50%)",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          visibility: "hidden", // Initially hidden
        }}
      >
        <IconButton onClick={prevSlide} sx={{ cursor: "pointer" }}>
          <img src={back} alt="back" width="50px" />
        </IconButton>
        <IconButton onClick={nextSlide} sx={{ cursor: "pointer" }}>
          <img src={forward} alt="forward" width="50px" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Slider;
